<template>
  <div>
    <div class='schedule-flow__success'>
      <div class='schedule-flow__success-icon-holder'>
        <i class='icon-check'/>
      </div>
      <div class='schedule-flow__success-content'>
        <div class='schedule-flow__success-title'>{{ locales.appointments && locales.appointments.viewing_scheduled }}</div>
        <div class='schedule-flow__success-text'>{{ locales.appointments && locales.appointments.you_will_receive_confirmation_mail }} <br>{{ locales.appointments && locales.appointments.we_will_send_you_reminder }}
        </div>
      </div>
    </div>
    <div class='schedule-flow__results'>
      <div class='mb-9'>
        <div class='schedule-flow__results-title'>{{locales.appointments && locales.appointments.guests}}</div>
        <div class='schedule-flow__results-value'>{{subscription.tenants.length}} {{subscription.tenants.length > 1 ? locales.appointments && locales.appointments.guests : locales.appointments && locales.appointments.guest}}</div>
      </div>
      <div class='theme-table__wrap mb-9' v-if="subscription && subscription.tenants">
        <table class='theme-table'>
          <tbody>
            <tr v-for='(user, index) in subscription.tenants' :key='index'>
              <td>{{ user.fullNameWithTitle }}</td>
              <td>€ {{ user.income }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class='mb-9'>
        <div class='schedule-flow__results-title'>{{locales.appointments && locales.appointments.date_and_time}}</div>
        <div class='schedule-flow__results-value'>
          <span>{{date.selectedDate}}</span>
          <span>●</span>
          <span>{{time}}</span>
          <a href='#' class='schedule-flow__results-link' @click.prevent='edit'>{{locales.common && locales.common.edit}}</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    props: {
      property: {
        default: () => {},
        type: Object,
      },
      subscription: {
        default: () => {},
        type: Object,
      }
    },
    data() {
      return {};
    },
    computed: {
      ...mapGetters(['locales']),
      date() {
        return this.$store.getters.getScheduleDate;
      },
      time() {
        return this.$store.getters.getScheduleTime;
      },
    },
    methods: {
      edit() {
        this.$store.commit('CHANGE_SCHEDULE_STEP', 1)
      }
    }
  };
</script>


// WEBPACK FOOTER //
// resources/js/components/ScheduleFlowConfirmation.vue